import { Globe, Monitor, Mic, Code2, Boxes, Network } from "lucide-react";
import { SectionHeader } from "./SectionHeader";

const TYPES = [
    {
        icon: Globe,
        title: "Browser use",
        desc: "Known segments of a site replay from the procedure. A layout change is detected and the agent falls back to reasoning.",
    },
    {
        icon: Monitor,
        title: "Computer use",
        desc: "Each step stores only what changed on screen. The target is named by what it is about, so a moved button still matches.",
    },
    {
        icon: Mic,
        title: "Voice agents",
        desc: "Routines taught in past sessions come back whole. Sensitivity gates at delivery, so the agent can know things it never says.",
    },
    {
        icon: Code2,
        title: "Coding agents",
        desc: "Procedures come from Claude Code and Codex sessions, no code changed. The command that verified the fix travels with the procedure.",
    },
    {
        icon: Boxes,
        title: "Other / custom / enterprise",
        desc: "Any harness sends one JSON trace to POST /v1/extract. Store it on your own machine, your database, or your Postgres. Consent is fail-closed.",
    },
    {
        icon: Network,
        title: "Multi-agent orchestration",
        desc: "A procedure one agent recorded is recalled by every other agent on the same store.",
    },
];

const AgentTypes = () => (
    <section id="agent-types" data-testid="agent-types-section" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
            <SectionHeader id="agent-types">One Memory For Every Agent Type</SectionHeader>
            <p className="-mt-6 mb-10 max-w-xl text-sm text-neutral-500">
                For anyone running agents that do the same work more than once.
            </p>
            <div className="grid gap-px border border-[#262626] bg-[#262626] sm:grid-cols-2 lg:grid-cols-3">
                {TYPES.map((t, i) => (
                    <div
                        key={t.title}
                        data-testid={`agent-type-${i}`}
                        className="group bg-[#050505] p-6 transition-colors duration-200 hover:bg-[#0a0a0a] sm:p-7"
                    >
                        <t.icon className="h-5 w-5 text-neutral-500 transition-colors group-hover:text-green-400" />
                        <h3 className="mt-4 text-lg font-medium text-neutral-100">{t.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-neutral-400">{t.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default AgentTypes;
